import email_active from '../img/tfnordic/sign-pn-icons/email-active.svg'
import email_inactive from '../img/tfnordic/sign-pn-icons/email-inactive.svg'
import sms_active from '../img/tfnordic/sign-pn-icons/sms-active.svg'
import sms_inactive from '../img/tfnordic/sign-pn-icons/sms-inactive.svg'

export interface ISignPnOtpButton {
	otpDistributionChannel: VideoIdSigningOtpMethod
	iconActive: string
	iconInactive: string
	title: string
	className: string
	show: boolean
}

export enum VideoIdSigningOtpMethod {
	Unknown = 'Unknown',
	Email = 'Email',
	SMS = 'SMS',
}

export enum VideoIdOtpSigningStep {
	OtpMethodSelection = 'OtpMethodSelection',
	OtpValidation = 'OtpValidation',
	PendingSigning = 'PendingSigning',
	Done = 'Done',
}

export const otpSignMethods: ISignPnOtpButton[] = [
	{
		otpDistributionChannel: VideoIdSigningOtpMethod.SMS,
		iconActive: sms_active,
		iconInactive: sms_inactive,
		title: 'OtpMethodSms',
		className: 'sms-otp',
		show: true,
	},
	{
		otpDistributionChannel: VideoIdSigningOtpMethod.Email,
		iconActive: email_active,
		iconInactive: email_inactive,
		title: 'OtpMethodEmail',
		className: 'email-otp',
		show: true,
	},
]

export enum VideoVerificationStatus {
	Accepted = 'Accepted',
	Rejected = 'Rejected',
}